import React, { FC, HTMLProps, useEffect, useState } from "react";

type Value = string | number;
interface Props extends Omit<HTMLProps<HTMLDivElement>, "onChange" | "value"> {
  value?: Value;
  onChange?: (v: Value) => void;
}

const RadioGroup: FC<Props> = ({ value, onChange, children, ...props }) => {
  // START value handling
  const [localValue, setLocalValue] = useState<Value>();

  const onChanges = (v: Value) => {
    setLocalValue(v);
    onChange?.(v);
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const displayValue = value ?? localValue;
  // END value handling

  return (
    <div {...props}>
      {React.Children.toArray(children).map((child) => {
        if (!child) {
          return null;
        }
        if (!React.isValidElement(child)) {
          return child;
        }
        return React.cloneElement(child, {
          onSelect: onChanges,
          selected: child.props.value === displayValue,
        });
      })}
    </div>
  );
};

export default RadioGroup;
